var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-calendar-card[data-v-fc768806]{position:relative;text-align:center;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-align:center;align-items:center;background-color:#f3f3f3;width:147px;height:175px;background-color:#fff;padding:0 5px}.page-calendar-card__date[data-v-fc768806]{padding-top:10px;color:#333254;font-size:45px}.page-calendar-card__date_red[data-v-fc768806]{color:#d35959}.page-calendar-card__month[data-v-fc768806]{padding-top:10px;color:rgba(0,0,0,.85) 0;font-size:12px;text-transform:uppercase}.page-calendar-card__info[data-v-fc768806]{background:url(" + escape(require("./wave.png")) + ") center 7px no-repeat;padding-top:20px;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fc768806","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/calendar/card/component.vue
// module id = 295669806da2a8ce706d
// module chunks = 0